import React, { useEffect, useState } from 'react';

import { KuposModal } from '../../common';
import getIcons from '../functions/getIcons/getIcons';

const ThemePopup = ({ operator }) => {
	const [showModal, setShowModal] = useState(false);
	useEffect(() => {
		const showPopup = operator && operator.show_popup && operator.popup_image;
		if (showPopup) {
			// Set a timeout to show the modal after 30000ms (30 seconds)
			const timer = setTimeout(() => {
				setShowModal(true);
			}, 3000);

			// Clean up the timer if the component unmounts or conditions change
			return () => clearTimeout(timer);
		} else {
			setShowModal(false);
		}
	}, [operator]);

	const closeModal = () => {
		setShowModal(false);
	};

	return (
		setShowModal && (
			<div className="themes-theme-two-popup">
				<KuposModal
					ariaLabel="tnc-pnr-modal-outer"
					// size={(operator && operator.operator_name === ('cormarbus') || operator && operator.operator_name === ('andimar')) ? 'md' : 'lg'}
					size={operator && operator.popup_size ? operator.popup_size : ''}
					onHide={closeModal}
					showModal={showModal}
					noBackground
					noPadding
				>
					<div className="bip-info-modal-container">
						<img src={operator.popup_image} alt="" />

						<div className="close-button pointer" onClick={closeModal}>
							<img src={getIcons('close', operator)} alt="" />
						</div>
					</div>
				</KuposModal>
			</div>
		)
	);
};

export default ThemePopup;



// WEBPACK FOOTER //
// ./src/features/themes/common/ThemePopup.js